import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ai-action"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      ($props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Icon, {
              width: "1.6rem",
              height: "1.6rem",
              icon: "arrow-up",
              class: _normalizeClass(["icon", {down: $props.arrowDown}]),
              stroke: "white"
            }, null, 8 /* PROPS */, ["class"]),
            _cache[0] || (_cache[0] = _createTextVNode(" Agent requires your action "))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}